import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
const _excluded = ["timestamp", "intl", "year", "futureDate", "theme"];
var _class,
  _RelativeTimestamp,
  _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/relative_timestamp.js";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { Text } from './ui';
const messages = defineMessages({
  just_now: {
    "id": "relative_time.just_now",
    "defaultMessage": "now"
  },
  seconds: {
    "id": "relative_time.seconds",
    "defaultMessage": "{number}s"
  },
  minutes: {
    "id": "relative_time.minutes",
    "defaultMessage": "{number}m"
  },
  hours: {
    "id": "relative_time.hours",
    "defaultMessage": "{number}h"
  },
  days: {
    "id": "relative_time.days",
    "defaultMessage": "{number}d"
  },
  moments_remaining: {
    "id": "time_remaining.moments",
    "defaultMessage": "Moments remaining"
  },
  seconds_remaining: {
    "id": "time_remaining.seconds",
    "defaultMessage": "{number, plural, one {# second} other {# seconds}} left"
  },
  minutes_remaining: {
    "id": "time_remaining.minutes",
    "defaultMessage": "{number, plural, one {# minute} other {# minutes}} left"
  },
  hours_remaining: {
    "id": "time_remaining.hours",
    "defaultMessage": "{number, plural, one {# hour} other {# hours}} left"
  },
  days_remaining: {
    "id": "time_remaining.days",
    "defaultMessage": "{number, plural, one {# day} other {# days}} left"
  }
});
const dateFormatOptions = {
  hour12: false,
  year: 'numeric',
  month: 'short',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit'
};
const shortDateFormatOptions = {
  month: 'short',
  day: 'numeric'
};
const SECOND = 1000;
const MINUTE = 1000 * 60;
const HOUR = 1000 * 60 * 60;
const DAY = 1000 * 60 * 60 * 24;
const MAX_DELAY = 2147483647;
const selectUnits = delta => {
  const absDelta = Math.abs(delta);
  if (absDelta < MINUTE) {
    return 'second';
  } else if (absDelta < HOUR) {
    return 'minute';
  } else if (absDelta < DAY) {
    return 'hour';
  }
  return 'day';
};
const getUnitDelay = units => {
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_DELAY;
  }
};
export const timeAgoString = (intl, date, now, year) => {
  const delta = now - date.getTime();
  let relativeTime;
  if (delta < 10 * SECOND) {
    relativeTime = intl.formatMessage(messages.just_now);
  } else if (delta < 7 * DAY) {
    if (delta < MINUTE) {
      relativeTime = intl.formatMessage(messages.seconds, {
        number: Math.floor(delta / SECOND)
      });
    } else if (delta < HOUR) {
      relativeTime = intl.formatMessage(messages.minutes, {
        number: Math.floor(delta / MINUTE)
      });
    } else if (delta < DAY) {
      relativeTime = intl.formatMessage(messages.hours, {
        number: Math.floor(delta / HOUR)
      });
    } else {
      relativeTime = intl.formatMessage(messages.days, {
        number: Math.floor(delta / DAY)
      });
    }
  } else if (date.getFullYear() === year) {
    relativeTime = intl.formatDate(date, shortDateFormatOptions);
  } else {
    relativeTime = intl.formatDate(date, _objectSpread(_objectSpread({}, shortDateFormatOptions), {}, {
      year: 'numeric'
    }));
  }
  return relativeTime;
};
const timeRemainingString = (intl, date, now) => {
  const delta = date.getTime() - now;
  let relativeTime;
  if (delta < 10 * SECOND) {
    relativeTime = intl.formatMessage(messages.moments_remaining);
  } else if (delta < MINUTE) {
    relativeTime = intl.formatMessage(messages.seconds_remaining, {
      number: Math.floor(delta / SECOND)
    });
  } else if (delta < HOUR) {
    relativeTime = intl.formatMessage(messages.minutes_remaining, {
      number: Math.floor(delta / MINUTE)
    });
  } else if (delta < DAY) {
    relativeTime = intl.formatMessage(messages.hours_remaining, {
      number: Math.floor(delta / HOUR)
    });
  } else {
    relativeTime = intl.formatMessage(messages.days_remaining, {
      number: Math.floor(delta / DAY)
    });
  }
  return relativeTime;
};
let RelativeTimestamp = injectIntl(_class = (_RelativeTimestamp = class RelativeTimestamp extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      now: Date.now()
    });
  }
  shouldComponentUpdate(nextProps, nextState) {
    // As of right now the locale doesn't change without a new page load,
    // but we might as well check in case that ever changes.
    return this.props.timestamp !== nextProps.timestamp || this.props.intl.locale !== nextProps.intl.locale || this.state.now !== nextState.now;
  }
  UNSAFE_componentWillReceiveProps(prevProps) {
    if (this.props.timestamp !== prevProps.timestamp) {
      this.setState({
        now: Date.now()
      });
    }
  }
  componentDidMount() {
    this._scheduleNextUpdate(this.props, this.state);
  }
  UNSAFE_componentWillUpdate() {
    this._scheduleNextUpdate();
  }
  componentWillUnmount() {
    clearTimeout(this._timer);
  }
  _scheduleNextUpdate() {
    clearTimeout(this._timer);
    const {
      timestamp
    } = this.props;
    const delta = new Date(timestamp).getTime() - this.state.now;
    const unitDelay = getUnitDelay(selectUnits(delta));
    const unitRemainder = Math.abs(delta % unitDelay);
    const updateInterval = 1000 * 10;
    const delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);
    this._timer = setTimeout(() => {
      this.setState({
        now: Date.now()
      });
    }, delay);
  }
  render() {
    const _this$props = this.props,
      {
        timestamp,
        intl,
        year,
        futureDate,
        theme
      } = _this$props,
      textProps = _objectWithoutProperties(_this$props, _excluded);
    const date = new Date(timestamp);
    const relativeTime = futureDate ? timeRemainingString(intl, date, this.state.now) : timeAgoString(intl, date, this.state.now, year);
    return /*#__PURE__*/React.createElement(Text, _extends({}, textProps, {
      theme: theme,
      tag: "time",
      title: intl.formatDate(date, dateFormatOptions),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 184,
        columnNumber: 7
      }
    }), relativeTime);
  }
}, _defineProperty(_RelativeTimestamp, "propTypes", {
  intl: PropTypes.object.isRequired,
  timestamp: PropTypes.string.isRequired,
  year: PropTypes.number.isRequired,
  theme: PropTypes.string,
  futureDate: PropTypes.bool
}), _defineProperty(_RelativeTimestamp, "defaultProps", {
  year: new Date().getFullYear(),
  theme: 'inherit'
}), _RelativeTimestamp)) || _class;
export { RelativeTimestamp as default };